import React from "react";
import PropTypes from "prop-types";

import SplitLayout from "components/Library/Layout/components/SplitLayout";
import BylinePhoto from "cards/components/BylinePhoto";
import Byline from "cards/components/Byline";
import PubDate from "cards/components/PubDate";

export default function BylineWrapper({ story, className }) {
  return (
    <SplitLayout
      left={
        <>
          <BylinePhoto photoSrc={story.byline_photo} />
          <Byline authors={story.authors} />
          <PubDate story={story} />
        </>
      }
      className={className}
    />
  );
}

BylineWrapper.propTypes = {
  story: PropTypes.object.isRequired,
  className: PropTypes.string,
};
